import * as ERRORS from '../constants/apiCodes';
import { INTERNAL_SERVER_ERR_MSG } from '../constants/constants';

export const getRegistrationErrorDetail = (errorCd) => {
  switch (errorCd) {
    case ERRORS.RSVP_EXPIRED_CD:
    case ERRORS.REG_EXPIRED_CD:
    case ERRORS.RSVP_INVALID_CD:
    case ERRORS.REG_INVALID_CD:
    case ERRORS.REG_REJECTED_CD:
      return {
        status: 'failed',
        additionalMessage: ERRORS.CONTACT_AMEX_MSG,
      };
    case ERRORS.EMAIL_ID_ALREADY_REGISTERED_CD:
      return {
        status: 'failed',
        message: ERRORS.EMAIL_ID_ALREADY_REGISTERED_MSG,
        additionalMessage: ERRORS.CONTACT_AMEX_MSG,
      };
    case ERRORS.RSVP_ALREADY_USED_CD:
    case ERRORS.REG_COMPLETED_CD:
    case ERRORS.USER_ALREADY_REGISTER:
      return {
        status: 'info',
        additionalMessage: ERRORS.CONTACT_AMEX_MSG,
      };
    default:
      return {
        status: 'failed',
        message: INTERNAL_SERVER_ERR_MSG,
        additionalMessage: ERRORS.CONTACT_AMEX_MSG,
      };
  }
};
